import { Box, BoxProps } from '@homebotapp/hb-react-component-catalog'

export const MobileShortcutsDrawerHeader = (props: BoxProps) => <Box {...props} />
